import { Grid, Stack } from '@mui/material';
import CustomButton from './Button';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import PropTypes from 'prop-types';
import { useBracketStrengthHook } from 'pages/bracketStrengths/useBracketStrengthHook';
import CustomDropdown from './CustomDropdown';
import Input from './Input';
import ErrorForSelect from './ErrorForSelect';
import { preventChars } from 'utils/utils';
import Loader from 'components/Loader';

const dropDown = [
  {
    id: 'bracketId',
    name: 'bracketType',
    label: 'Bracket Type',
    required: true
  },

  {
    id: 'materialId',
    name: 'materialName',
    label: 'Bracket Material',
    required: true
  },

  {
    id: 'sheathingId',
    name: 'sheathingName',
    label: 'Sheathing Type',
    required: false
  },

  {
    id: 'fastenerId',
    name: 'fastenerName',
    label: 'Fastener Type',
    required: false
  },
  {
    id: 'seamId',
    name: 'seamName',
    label: 'Seam Type',
    required: false
  }
];

const BracketStrengthForm = ({
  bracketType,
  bracketInfo,
  buttonText,
  buttonClose,
  handleSubmit,
  handleCancelAction,
  handleBracketInfo,
  error,
  handleError
}) => {
  const dropDownOptions = useBracketStrengthHook();
  return (
    <form onSubmit={handleSubmit}>
      <Grid container xs={12}>
        {dropDown.map(({ id, name, label, required }) => {
          return (
            <Grid item xs={6} key={name} sx={{ marginTop: '3vh' }}>
              <CustomDropdown
                styles={{ width: '350px' }}
                value={bracketInfo[id]}
                error={error[name]}
                onFocus={() => handleError(name, null)}
                onChange={handleBracketInfo}
                list={name == 'bracketType' ? bracketType : dropDownOptions[name]}
                name={id}
                isId={true}
                label={label}
                isRequired={required}
              />
              {error[name] && (
                <ErrorForSelect style={{ marginTop: 8, marginLeft: '3vh' }}>
                  {error[name]}
                </ErrorForSelect>
              )}
            </Grid>
          );
        })}

        <Grid item xs={6} sx={{ marginTop: '4vh' }}>
          <Input
            sx={{ width: '350px', mx: '3vh' }}
            inputProps={{
              step: 0.01
            }}
            type="number"
            placeholder="Enter Bracket Strength"
            onChange={handleBracketInfo}
            value={bracketInfo.strength}
            required={true}
            label={'Bracket Strength'}
            onFocus={() => handleError('strength', null)}
            name="strength"
            onKeyDown={(event) => preventChars(event)}
            error={error.strength}
          />
        </Grid>
      </Grid>

      <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ mr: '3vh' }}>
        {!bracketInfo?.strengthId && (
          <CustomButton
            sx={{ ml: '15vh' }}
            type="submit"
            onClick={handleSubmit}
            endIcon={buttonText === 'Save' ? <SaveIcon /> : <AddIcon />}>
            {buttonText}
          </CustomButton>
        )}
        {buttonText !== 'Save' && (
          <CustomButton type="button" endIcon={<SaveIcon />} onClick={handleCancelAction}>
            {bracketInfo?.strengthId ? 'Save' : buttonClose}
          </CustomButton>
        )}
      </Stack>
      {dropDownOptions.showLoader && <Loader open={dropDownOptions.showLoader} />}
    </form>
  );
};

BracketStrengthForm.propTypes = {
  bracketType: PropTypes.array,
  bracketInfo: PropTypes.object,
  setBracketInfo: PropTypes.func,
  buttonText: PropTypes.string,
  buttonClose: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleCancelAction: PropTypes.func,
  handleBracketInfo: PropTypes.func,
  handleError: PropTypes.func,
  types: PropTypes.array,
  material: PropTypes.array,
  bracket: PropTypes.object,
  error: PropTypes.object
};

export default BracketStrengthForm;
